// src/pages/Gallery/GalleryPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./GalleryPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const GalleryPage = () => {
  const [events, setEvents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const eventsPerPage = 5;
  const navigate = useNavigate(); // <-- useNavigate hook

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/gallery`);
      setEvents(res.data);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this event?"))
      return;

    try {
      await axios.delete(`${API_BASE_URL}/gallery/${id}`);
      fetchEvents();
    } catch (error) {
      console.error("Error deleting event:", error);
    }
  };

  // Pagination logic
  const indexOfLast = currentPage * eventsPerPage;
  const indexOfFirst = indexOfLast - eventsPerPage;
  const currentEvents = events.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(events.length / eventsPerPage);

  return (
    <div className="gallery-container">
      <h2 className="page-title">Gallery Management</h2>

      {/* Add Event button navigates */}
      <button
        className="add-btn"
        onClick={() => navigate("/admin-panel/gallery/add-event")}
      >
        + Add Event
      </button>

      <div className="table-wrapper">
        <table className="gallery-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Event Title</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentEvents.length === 0 ? (
              <tr>
                <td colSpan="3" className="no-data">
                  No events found
                </td>
              </tr>
            ) : (
              currentEvents.map((event, index) => (
                <tr key={event._id}>
                  <td>{indexOfFirst + index + 1}</td>
                  <td>{event.eventTitle}</td>
                  <td>
                    {/* Add Photos button navigates to /gallery/:id/photos */}
                    <button
                      className="action-btn view-btn"
                      onClick={() =>
                        navigate(`/gallery/${event._id}/photos`)
                      }
                    >
                      Add Photos
                    </button>
                    <button
                      className="action-btn delete-btn"
                      onClick={() => handleDelete(event._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Previous
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;